import React from "react";

import { Box, LinearProgress, Typography } from "@mui/material";

interface ProgressBarProps {
  progress: number; // 0-100
  fileName?: string;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  fileName,
  progress,
}) => {
  return (
    <Box sx={{ mb: 1, mt: 1, width: "100%" }}>
      {fileName && (
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {fileName}
        </Typography>
      )}
      <Box sx={{ alignItems: "center", display: "flex" }}>
        <Box sx={{ mr: 1, width: "100%" }}>
          <LinearProgress variant="determinate" value={progress} />
        </Box>
        <Box sx={{ minWidth: 35 }}>
          <Typography variant="body2" color="text.secondary">
            {Math.round(progress)}%
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
